import { Extension, type Editor } from '@tiptap/core'

export type OpenImagePicker = (onPick: (url: string) => void) => void

export interface ImagePickerStorage {
    openPicker: OpenImagePicker | null
}

const STORAGE_KEY = 'imagePicker'

/**
 * Holds a reference to the React-side image picker so any extension (slash
 * command, image node view, bubble menu...) can summon the shared media library
 * without prop-drilling. Set from <EmailBuilder/> via useEffect.
 */
export const ImagePickerStorageExtension = Extension.create({
    name: STORAGE_KEY,

    addStorage(): ImagePickerStorage {
        return { openPicker: null }
    },
})

export function getImagePickerStorage(
    editor: Editor | null | undefined,
): ImagePickerStorage | undefined {
    if (!editor) return undefined
    const storage = editor.storage as unknown as Record<string, unknown>
    return storage[STORAGE_KEY] as ImagePickerStorage | undefined
}

export function summonImagePicker(
    editor: Editor | null | undefined,
    onPick: (url: string) => void,
): void {
    const open = getImagePickerStorage(editor)?.openPicker
    if (open) {
        open(onPick)
        return
    }
    const fallback = window.prompt('Image URL')
    if (fallback) onPick(fallback)
}
